export default __webpack_public_path__ + "static/media/close-shop.4615d9fa.svg";